import React from 'react';
import { UpdateWorkspace } from '../../../../shared/types/workspaceTypes';
import { Body, Headline } from '../../../../shared/styled-components/styled_text';
import styled from 'styled-components';
import { ApplicationPreview } from './ApplicationPreview';
import { FlexRow } from '../../../../shared/FlexRow';

interface Props {
  data: UpdateWorkspace;
  handleClose?: () => void;
}

export const OnboardingStep2Preview: React.FC<Props> = ({ data, handleClose }) => {
  return (
    <Container className={'page-container'}>
      <SafeAreaContent>
        <Header>
          <button onClick={handleClose}>
            <CloseIcon />
          </button>
          <Headline size={'s'}>채용 사이트 예시 미리보기</Headline>
        </Header>
        <FlexRow
          width={'100%'}
          justify={'center'}
          align={'center'}
          style={{ height: 'fit-content', padding: '0.6rem 1.2rem', backgroundColor: 'var(--mono-op-08)' }}
        >
          <Body size={'s'} style={{ color: 'var(--content-color-secondary)' }}>
            채용 사이트는 구독 요금제 사용자만 이용할 수 있어요.
          </Body>
        </FlexRow>
        <ApplicationPreview />
      </SafeAreaContent>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100vh;
  background-color: var(--background-1);
  z-index: 2000;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;

  padding: env(safe-area-inset-top, 0px) env(safe-area-inset-right, 0px) env(safe-area-inset-bottom, 0px) env(safe-area-inset-left, 0px);

  * {
    box-sizing: border-box;
  }
`;

const SafeAreaContent = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: hidden;
  position: relative;
`;

const Header = styled.div`
  width: 100%;
  height: 5.6rem;
  padding: 0 1.6rem 1.2rem;
  background-color: var(--background-1);
  border-bottom: 1px solid var(--border-color);

  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 1.2rem;
`;

const CloseIcon = styled.div`
  width: 2.4rem;
  height: 2.4rem;
  mask-image: url('/images/common/chevron.svg');
  mask-size: cover;
  mask-repeat: no-repeat;
  background-color: var(--content-color-primary);
`;
